import React, { ReactElement, ReactNode } from 'react';

import UploadControl from '../_UploadControl';
import { UploadControlProps } from '../_UploadControl/UploadControl';
import UploadButton from '../UploadButton';

export interface UploadButtonControlProps<Value, StateValue> extends Omit<UploadControlProps<Value, StateValue>, 'Target'> {
  children?: ReactNode;
  defaultValue?: UploadControlProps<Value, StateValue>['defaultValue'];
  multiple?: UploadControlProps['multiple'];
}

const UploadButtonControlDefaultProps: Partial<UploadButtonControlProps<any, any>> = {
  defaultValue: [],
  multiple: false,
};

const UploadButtonControl = <Value =(File | string)[], StateValue = File[]>(props: UploadButtonControlProps<Value, StateValue>): ReactElement<UploadButtonControlProps<Value, StateValue>> => (
  <UploadControl<Value, StateValue> Target={UploadButton} {...props} />
);

UploadButtonControl.defaultProps = UploadButtonControlDefaultProps;

export default UploadButtonControl;
